module.exports = {
  base_url:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:9000/",
  api_base_url:
    process.env.REACT_APP_API_BASE_URL || "http://localhost:9000/",
  open_ai_api_key:
    process.env.open_ai_api_key ||
    "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",
};
